import { snakeCaseKeys } from '@/utils/transformKeys';

const joinNonEmptyParams = (params = {}, snakeCase = true) => {
  const filteredParams = Object.entries(params).reduce((obj, [key, value]) => {
    let val = value;
    if (Array.isArray(value)) {
      val = value.join(',');
    }
    return typeof val === 'undefined' || val === '' || val === null
      ? obj
      : { ...obj, [key]: val };
  }, {});
  const nonEmptyParams = new URLSearchParams(
    snakeCase ? snakeCaseKeys(filteredParams) : filteredParams,
  );
  nonEmptyParams.sort();
  return nonEmptyParams.toString();
};

export default joinNonEmptyParams;
